<script>
import { readOneMenu, deleteOneMenu
, updateOneSingleMealInMenu,
} from '@/services/MenuMakerServices';
export default {
  props: ['menuStartDate'],
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      //
      menu: null,
      //
      loading: true,
      showDialogToDeleteThisMenu: false,
      // MODAL: EDIT A MEAL
      showEditMealModal: false,
      editMealDay: null, // 0-5
      editMealNum: '', // 'meal1'
      editMealItem: '', // '...'
    };
  },
  methods: {
    async deleteThisEntireMenu() {
      await deleteOneMenu(this.uId, this.token, this.menuStartDate);
      await this.$nextTick();

      // window.location.href = '/menus';
      this.$router.push('/menus');
    },
    printMenu() {
      const printable = document.getElementById('page-one-menu');
      if (!printable) return;

      const printContents = printable.innerHTML;

      const printWindow = window.open('', '_blank', 'width=1200,height=800');

      printWindow.document.write(`
        <!DOCTYPE html>
        <html lang="en">
          <head>
            <meta charset="UTF-8">
            <title>Menu - ${this.menu?.selectedWeekDays[0]?.display} to ${this.menu?.selectedWeekDays[6]?.display}</title>
            <style>
              @page {
                size: landscape;
                margin: 0.4in;
              }

              body {
                font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                margin: 0;
                padding: 16px;
                background: white;
                color: #000;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              h1 {
                text-align: center;
                margin: 0 0 16px 0;
                font-size: 22px;
                text-decoration: underline;
              }

              #table-menu-data {
                overflow: visible;
              }

              table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
                font-size: 12.5px;
              }

              th, td {
                border: 1px solid #333;
                padding: 7px 9px;
                text-align: left;
                /*vertical-align: top;*/
                white-space: pre-line;
                word-wrap: break-word;
              }

              th {
                background-color: #f1f1f1;
                font-weight: 700;
                text-align: center;
              }

              td:first-child,
              th:first-child {
                background-color: #e8e8e8;
                font-weight: 700;
                text-align: center;
                width: 78px;
                min-width: 78px;
              }

              /* Keep rows together and fit on one page */
              tr {
                page-break-inside: avoid;
              }

              /* Make day columns a bit more readable */
              td:not(:first-child) {
                min-width: 118px;
              }
            </style>
          </head>
          <body>
            ${printContents}
          </body>
        </html>
      `);

      printWindow.document.close();

      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        // Uncomment the line below if you want the print window to auto-close after printing
        setTimeout(() => printWindow.close(), 300);
      };
    },
    async showMeAnEditMealModal(dayNum, mealNum) {
      this.editMealDay = dayNum;
      this.editMealNum = mealNum;
      this.editMealItem = this.menu.menu[dayNum].meals[mealNum];
      console.log('*** starting showMeAnEditMealModal() ***', dayNum, mealNum, this.editMealItem);
      await this.$nextTick();

      this.showEditMealModal = true;
    },
    async cancelEditMeal() {
      console.log('*** starting cancelEditMeal ***');
      this.showEditMealModal = false;
      await this.$nextTick();

      this.editMealDay = null;
      this.editMealNum = this.editMealItem = '';
    },

    async updateOneMealInMenu() {
      console.log('*** starting updateOneMealInMenu() ***');

      // form data
      const mealText = this.editMealItem.trim();
      
      // services
      const successfullyUpdatedOneMealInMenu = await updateOneSingleMealInMenu(this.uId, this.token, this.menuStartDate, this.editMealDay, this.editMealNum, mealText);
      
      // success
      if (successfullyUpdatedOneMealInMenu) {
        this.menu.menu[this.editMealDay].meals[this.editMealNum] = mealText;
        await this.$nextTick();

        await this.cancelEditMeal();
      }

    },
  },
  async created() {
    console.clear();

    console.log('*** url menuStartDate ***', this.menuStartDate);

    const m = await readOneMenu(this.uId, this.token, this.menuStartDate);
    if (m) {
      this.menu = m;
      console.log('*** this.menu ***', this.menu);
      this.loading = false;
    }
  },
}
</script>

<template>
  <div v-if="loading" class="pt-8 text-center">
    <v-progress-circular color="green-lighten-3" indeterminate></v-progress-circular>
  </div>
  <div v-else>

    <!-- link: back to all menus -->
    <div class="pt-4 px-4">
      <router-link to="/menus" class="text-body-2 font-italic text-decoration-none text-red-lighten-2">
        <span class="mdi mdi-chevron-left"></span> Go back to All Menus
      </router-link>
    </div>


    <!-- This is the ONLY thing that gets printed -->
    <div id="page-one-menu" class="px-4">

      <h1 class="mb-8 text-center text-decoration-underline">
        Menu for <br />
        {{ menu?.selectedWeekDays[0]?.display }} - {{ menu?.selectedWeekDays[6]?.display }}
      </h1>

      <!-- table -->
      <div id="table-menu-data">
        <v-table v-if="menu" fixed-header class="sticky-table">
          <thead>
            <tr>
              <th class="bg-grey-lighten-2 sticky-col">&nbsp;</th>
              <th v-for="(day, index) in menu.menu" :key="index" class="bg-grey-lighten-2">
                {{ day.date?.display }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="mealNum in 6" :key="mealNum">
              <td class="bg-grey-lighten-2 sticky-col text-center"><strong>Meal {{ mealNum }}</strong></td>
              <td v-for="(day, i) in menu.menu" :key="i">
                <div :class="day.meals[`meal${mealNum}`] ? 'cell-has-content' : ''"
                     class="d-flex flex-column justify-space-between align-start">
                  <h3>{{ day.meals[`meal${mealNum}`] || '' }}</h3>
                  <p v-if="day.meals[`meal${mealNum}`]"
                     @click.prevent="showMeAnEditMealModal(i, `meal${mealNum}`)"
                     class="mx-auto mt-4 font-italic text-lowercase text-grey cursor-pointer"
                  >edit</p>
                  <p v-else @click.prevent="showMeAnEditMealModal(i, `meal${mealNum}`)"
                     class="mx-auto my-auto font-italic text-lowercase text-grey cursor-pointer"
                  >add a meal</p>
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>

    </div>
    <!-- end print area -->


    <!-- Print buttons (placed OUTSIDE the printable area) -->
    <div class="mt-8 mb-16 pb-16 px-4 d-flex justify-space-between justify-sm-space-around">
      <v-btn @click.prevent="showDialogToDeleteThisMenu = true"
             color="red-lighten-2"
             class="text-capitalize text-white"
      >Delete this Menu</v-btn>
      <v-btn @click.prevent="printMenu"
             color="green-lighten-1"
             prepend-icon="mdi-printer"
      >Print Menu</v-btn>
    </div>


    <!-- MODAL: Delete this Menu -->
    <v-dialog v-model="showDialogToDeleteThisMenu">
      <v-card>
        <v-toolbar>
          <v-btn @click.prevent="showDialogToDeleteThisMenu = false"
                 icon="mdi-close"
          ></v-btn>
          <h2>Confirm: Delete this Menu</h2>
        </v-toolbar>
        <v-card-text>
          <div class="px-4 py-8">
            <p>Are you sure you want to delete this Entire Menu?</p>
            <div class="mt-8 d-flex justify-space-between align-center">
              <v-btn @click="showDialogToDeleteThisMenu = false"
                     color="grey"
                     class="me-auto text-capitalize"
                     variant="outlined"
                     density="compact"
              >Cancel</v-btn>
              <v-btn @click="deleteThisEntireMenu"
                     variant="flat"
                     color="red-lighten-2"
                     class="ms-auto"
              >Yes, Delete</v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>


    <!-- MODAL: EDIT A MEAL -->
    <v-dialog v-model="showEditMealModal" fullscreen>
      <v-card>
        <v-card-title class="bg-grey-lighten-2">Edit a Meal</v-card-title>
        <v-card-text>
          <h3 class="py-4 px-2">{{ menu?.menu[editMealDay]?.date?.display }} —> <i class="text-capitalize">{{ editMealNum }}</i></h3>
          <v-textarea v-model="editMealItem"
                      variant="outlined"
                      rows="4" auto-grow
                      clearable
                      placeholder="add a meal"
          ></v-textarea>
          <div class="d-flex justify-space-between">
            <v-btn @click.prevent="cancelEditMeal"
                   variant="outlined"
                   color="red-lighten-2"
            >Cancel</v-btn>
            <v-btn @click.prevent="updateOneMealInMenu"
                   color="green-lighten-1"
            >Save Changes</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<style scoped lang="scss">
#page-one-menu {

  #table-menu-data {
    overflow: auto;

    .sticky-table {
      table {
        border-collapse: collapse;
        min-width: 100%; /* ensures horizontal scroll appears */
      }
    }

    th, td {
      border: 0.5px solid gray;
      white-space: pre-line;
      padding: 8px 12px;
      text-align: left;
    }
    th {
      text-align: center;
      position: sticky;
      top: 0;
      z-index: 10;
      font-weight: bold;
      &:first-child {
        min-width: 84px;
        left: 0;
        z-index: 20; /* higher z so it sits on top of other headers */
      }
      &:not(:first-child) { min-width: 124px; }
    }
    .sticky-col {
      position: sticky;
      left: 0;
      z-index: 15;
      font-weight: bold;
    }
    td .cell-has-content {
      min-width: 258px;
      height: 100%;
      min-height: 120px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

  } /* end #table-menu-data */

}
</style>
